import { defaultToolbarItems } from '@/lib/components/Shared/editor/ckeditor/toolbar/Toolbar';
import { PropType } from 'vue';
import type { ToolbarConfigItem } from 'ckeditor5';
import { useLinksDao } from '@/domain/dao/Links';

const { markdown_guide: markdownGuide } = useLinksDao();

export const useEditorProps = {
	value: {
		type: String,
		default: '',
	},
	name: {
		type: String,
		default: null,
	},
	fieldName: {
		type: String,
		default: '',
	},
	spellChecker: {
		type: Boolean,
		default: true,
	},
	markdownGuideLabel: {
		type: String,
		default: 'About Markdown formatting',
	},
	markdownGuideUrl: {
		type: String,
		default: markdownGuide,
	},
	placeholder: {
		type: String,
		default: null,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	id: {
		type: String,
		default: 'text-editor',
	},
	inActiveTab: {
		type: Boolean,
		default: false,
	},
	useHiddenInput: {
		type: Boolean,
		default: false,
	},
	inputClass: {
		type: String,
		default: '',
	},
	toolbar: {
		type: Array as PropType<ToolbarConfigItem[]>,
		default: () => defaultToolbarItems,
	},
	removeItemsToolbar: {
		type: Array as PropType<string[]>,
		default: () => [],
	},
	maximumCharacters: {
		type: Number,
		required: false,
	},
	maximumWords: {
		type: Number,
		required: false,
	},
};
